import type { BuyContractPriceOption } from '@erp/rpc';
import type { LegPriceBreak } from '@erp/shared-types';
import { agreementSavingOf } from './agreementSaving';

function hasCostSourceLabel(
  priceBreak: LegPriceBreak | null | undefined,
): boolean {
  if (priceBreak == null) return false;
  if (priceBreak.costSource === 'agreement') return true;
  if (
    priceBreak.costSource === 'price_break' &&
    priceBreak.tier != null &&
    priceBreak.unitCost != null
  ) {
    return true;
  }
  return false;
}

function hasAgreementSavingNote(
  priceBreak: LegPriceBreak | null | undefined,
  quantity: number | null | undefined,
): boolean {
  const saving = agreementSavingOf({ priceBreak, quantity });
  return saving !== null && saving.totalSaving !== 0;
}

export function shouldShowBuyCostPricingPopover({
  options,
  priceBreak,
  quantity,
}: {
  options: readonly BuyContractPriceOption[];
  priceBreak: LegPriceBreak | null | undefined;
  quantity: number | null | undefined;
}): boolean {
  if (options.length > 1) return true;
  if (hasCostSourceLabel(priceBreak)) return true;
  if (hasAgreementSavingNote(priceBreak, quantity)) return true;
  return false;
}
